export default __webpack_public_path__ + "media/components/Header/Images/Kerning_normal-6b1fa7257bb06d92c8f850fd7ef58367.svg";